import React, { ReactElement } from 'react';
import Head from 'next/head';

import { CoverLetterBuilder } from 'components/candidate/CoverLetterBuilder/CoverLetterBuilder.component';
import { getLayout } from 'components/layouts/Header';
import { withAuthCandidate } from 'lib/hocs/withAuthCandidate';
import { LOCALE_PAGES, fetchTranslationFiles } from 'lib/services/page';

const Build_cover_letter = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Build Cover Letter | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <CoverLetterBuilder />
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.CANDIDATE_COVER_LETTER_BUILDER],
      })),
    },
  };
}

const BuildCoverLetterWrapper = withAuthCandidate(Build_cover_letter);
// @ts-ignore
BuildCoverLetterWrapper.getLayout = getLayout;

export default BuildCoverLetterWrapper;
